import './index.scss';

interface ChangeGymHeaderProps {
  image: string;
}
const ChangeGymHeader = (props: ChangeGymHeaderProps) => {
  return (
    <div className="change-gym-header">
      <img src={props.image} alt="" />
    </div>
  );
};

export default ChangeGymHeader;
